'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var currentSubscriptionsSelector = exports.currentSubscriptionsSelector = function currentSubscriptionsSelector(_ref) {
  var currentSubscriptions = _ref.currentSubscriptions;
  return currentSubscriptions;
};


//////////////////
// WEBPACK FOOTER
// ./js/selectors/CurrentSubscriptionsSelectors.js
// module id = 525
// module chunks = 3 4